import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    realEstateAdminId: Number,
    crawlerId: Number
  }

  async runAll() {
    try {
      const modal = document.getElementById('test_all_retrievers_modal')
      const resultsBox = document.getElementById('test_all_retrievers_results')

      if (resultsBox) {
        resultsBox.innerHTML = this.loadingHTML()
      }
      if (modal && !modal.open) {
        modal.showModal()
      }

      const url = `/real_estate_admin/${this.realEstateAdminIdValue}/crawler/${this.crawlerIdValue}/test_all_retrievers`
      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.getCSRFToken()
        },
        body: JSON.stringify({})
      })

      const data = await resp.json()

      if (!data.success) {
        this.renderError(resultsBox, data.error || 'Erro ao executar testes')
        return
      }

      this.renderResults(resultsBox, data)
    } catch (e) {
      const resultsBox = document.getElementById('test_all_retrievers_results')
      this.renderError(resultsBox, e.message)
    }
  }

  renderResults(container, data) {
    if (!container) return
    const items = (data.results || []).map((r) => this.resultItemHTML(r)).join('')
    container.innerHTML = `
      <div class="mb-2 text-sm text-gray-600">Código usado: <span class="font-mono bg-gray-100 px-2 py-0.5 rounded">${data.sample_code}</span></div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">${items}</div>
    `
  }

  resultItemHTML(r) {
    if (r.status === 'success') {
      const title = r.title || '(sem título)'
      const price = [r.list_price, r.rental_price].filter((v) => v && v > 0).join(' / ')
      const link = r.detail_view_url ? `<a href="${r.detail_view_url}" target="_blank" class="text-blue-600 hover:underline">Abrir</a>` : '<span class="text-gray-400">Sem URL</span>'
      return `
        <div class="border border-green-200 bg-green-50 rounded p-3">
          <div class="flex items-center justify-between">
            <div class="font-semibold text-green-800">${this.prettyName(r.retriever_type)}</div>
            <div class="text-green-700 text-sm">✓ Sucesso</div>
          </div>
          <div class="text-sm text-green-700 mt-1">
            <div><span class="font-medium">Título:</span> ${this.escapeHtml(title)}</div>
            <div><span class="font-medium">Preço:</span> ${price || '—'}</div>
            <div class="mt-1">${link}</div>
          </div>
        </div>
      `
    } else {
      return `
        <div class="border border-red-200 bg-red-50 rounded p-3">
          <div class="flex items-center justify-between">
            <div class="font-semibold text-red-800">${this.prettyName(r.retriever_type)}</div>
            <div class="text-red-700 text-sm">✗ Erro</div>
          </div>
          <div class="text-sm text-red-700 mt-1">
            ${this.escapeHtml(r.error || 'Erro desconhecido')}
          </div>
        </div>
      `
    }
  }

  loadingHTML() {
    return `
      <div class="flex items-center justify-center py-6">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span class="ml-3 text-gray-600">Executando testes em paralelo...</span>
      </div>
    `
  }

  renderError(container, message) {
    if (!container) return
    container.innerHTML = `
      <div class="bg-red-50 border border-red-200 rounded p-3 text-red-700 text-sm">${this.escapeHtml(message)}</div>
    `
  }

  prettyName(s) {
    return (s || '').toString().replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  }

  escapeHtml(str) {
    return (str || '').toString().replace(/[&<>"]+/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]))
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta && meta.getAttribute('content')
  }
}

